import { Component, OnInit } from '@angular/core';
import { ApolloService } from '../services/apollo.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  constructor(private apolloService: ApolloService) {}
  ngOnInit(): void {
    this.apolloService.createClient();
  }
}
